import chartStyle from '@shopify/polaris-viz/build/esm/styles.css?url';
import { PolarisVizProvider } from '@shopify/polaris-viz';

export const GChartProvider = ({
  children,
  minHeight = 228,
  seriesColors,
}: {
  children: React.ReactNode;
  minHeight?: number;
  seriesColors?: {
    comparison?: string;
    single?: string;
    all?: string[];
  };
}) => {
  return (
    <>
      <link rel="stylesheet" href={chartStyle} />
      <PolarisVizProvider
        themes={{
          Light: {
            chartContainer: {
              minHeight,
            },
            grid: {
              horizontalOverflow: true,
              verticalOverflow: true,
              horizontalMargin: 0,
            },
            seriesColors: {
              comparison: 'rgba(64, 176, 230, 1)',
              single: 'rgba(64, 176, 230, 1)',
              all: ['#2C7DFF', '#F34A70'],
              ...seriesColors,
            },
          },
        }}
      >
        {children}
      </PolarisVizProvider>
    </>
  );
};
